import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { usePageTitle } from "@/hooks/usePageTitle";

export default function NotFound() {
  const { t } = useTranslation();
  usePageTitle(t("notFound.title"));

  return (
    <div className="max-w-[1280px] mx-auto w-full py-20 flex flex-col items-center gap-4 text-center">
      <h1 className="text-6xl font-bold text-brand">{t("notFound.title")}</h1>
      <p className="text-lg text-brand/80">{t("notFound.description")}</p>
      <Link
        to="/"
        className="mt-4 rounded-full px-6 py-2.5 text-sm font-medium text-white bg-brand hover:bg-brand/90 transition-colors duration-200"
      >
        {t("notFound.backHome")}
      </Link>
    </div>
  );
}
